import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Box sx={{ py: 6, textAlign: 'center' }}>
      <Box sx={{ color: 'text.secondary', mb: 2, '& > svg': { fontSize: 48 } }}>{icon}</Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            color: "text.secondary",
            mb: 2,
            maxWidth: 400,
            mx: 'auto'
          }}>
          {description}
        </Typography>
      )}
      {action}
    </Box>
  );
}
